import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(37.000000, 27.000000) scale(0.6,0.6)">
        <path
          
          
          d="M 50.1 64.7 L 43.5 71.5 L 9.5 38.1 L 9.5 70.3 L 0 70.3 L 0 0.3 L 9.5 0.3 L 9.5 32.2 L 39.3 0 L 45.7 5.9 L 18.4 34.3 L 50.1 64.7 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
